export default "$ yarn add @mdi/js -D\n// OR\n$ npm install @mdi/js -D\n";